import { render } from "./Materiais.vue?vue&type=template&id=195bcda9"
import script from "./Materiais.vue?vue&type=script&lang=js"
export * from "./Materiais.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__